@let gridData = $gridData();
@let T = gridData.data;
<unity-grid-shared
  gridTitle=""
  [gridData]="gridData"
  [gridError]="$gridError()"
  [gridLoading]="$gridLoading()"
  [isSortable]="false"
  [isFilterable]="false"
  [defaultSort]="defaultSort"
  (dataQueryEvent)="onDataQuery($event)">
  <kendo-grid-column field="name" title="Name">
    <ng-template let-item kendoGridCellTemplate [unityTyped]="T">
      @if (item.form_response) {
        <unity-link-gridcell-shared
          [displayText]="`${item.form_schedule.name} ${item.id}`"
          [link]="['/agreement', $agreementId(), 'form-instance', item.id, 'form-response', item.form_response.id]" />
      }
    </ng-template>
  </kendo-grid-column>
  @for (column of $columns(); track column.name) {
    @if (column.mapDisplayValue === true && column.choices) {
      <kendo-grid-column [title]="column.title" [field]="`form_response_data.${column.name}`">
        <ng-template let-item kendoGridCellTemplate [unityTyped]="T">
          @if (item.form_response_data) {
            {{ getDisplayValue(item.form_response_data[column.name], column.choices) }}
          }
        </ng-template>
      </kendo-grid-column>
    } @else if (column.inputType === 'date') {
      <kendo-grid-column filter="date" [field]="`form_response_data.${column.name}`" [title]="column.title">
        <ng-template let-item kendoGridCellTemplate [unityTyped]="T">
          @if (item.form_response_data && item.form_response_data[column.name]) {
            {{ item.form_response_data[column.name] | dateTimezone: 'MM/dd/yyyy' }}
          }
        </ng-template>
      </kendo-grid-column>
    } @else if (column.inputType === 'text') {
      @if (column.maskType === 'currency') {
        <kendo-grid-column filter="numeric" [field]="`form_response_data.${column.name}`" [title]="column.title">
          <ng-template let-item kendoGridCellTemplate [unityTyped]="T">
            @if (item.form_response_data) {
              <unity-gridcell-currency-shared [value]="item.form_response_data[column.name]" />
            }
          </ng-template>
        </kendo-grid-column>
      } @else {
        <kendo-grid-column [field]="`form_response_data.${column.name}`" [title]="column.title" />
      }
    } @else {
      <kendo-grid-column [field]="`form_response_data.${column.name}`" [title]="column.title" />
    }
  }
  <kendo-grid-column field="current_state.name" title="Status">
    <ng-template let-item kendoGridCellTemplate [unityTyped]="T">
      <unity-chip-workflow-state-shared [name]="item.current_state.name" [value]="item.current_state.enum_value" />
    </ng-template>
  </kendo-grid-column>
</unity-grid-shared>
